import React from "react";
import { Button, Form, Radio } from "antd";
import { DEFAULT_PURPOSE } from "@iso/constants/onboarding";

const PURPOSE_OPTIONS = [
  { value: "for_family_safety", label: "For family safety" },
  { value: "for_employee_safety", label: "For employee safety" },
  { value: "for_property_management", label: "For property management" },
  { value: "for_property_weather", label: "For property weather" },
  { value: "all_of_the_above", label: "All of the above" },
];

const PurposeStep = ({ purpose, onNext }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onNext(values.purpose);
  };

  return (
    <>
      <h1 className="ob-title" tabIndex={-1}>
        How are you planning to use AirAgri?
      </h1>
      <Form
        form={form}
        layout="vertical"
        name="onboarding_purpose"
        initialValues={{ purpose: purpose || DEFAULT_PURPOSE }}
        onFinish={handleFinish}
      >
        <Form.Item
          name="purpose"
          rules={[{ required: true, message: "Please choose an option" }]}
        >
          <Radio.Group className="ob-radio-list">
            {PURPOSE_OPTIONS.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <div className="ob-actions">
          <Button className="ob-btn-primary" htmlType="submit">
            Continue
          </Button>
        </div>
      </Form>
    </>
  );
};

export default PurposeStep;
